<app-access-item [small]="true">
  <app-access-item-header>
    <div>Transform</div>
  </app-access-item-header>

  <app-access-item-cta>
    <app-context-menu
      [options]="{ width: '260px', noSpacing: true }"
      [position]="'right'"
      #menu
      name="text-transform-menu"
    >
      <button
        appButton
        name="text-transform-menu"
        location="theme-text-transform-item"
        [hasIcon]="true"
        color="simple"
        height="0"
        spacing="1"
        weight="bold"
        contextButton
      >
        <span>{{ textTransform() || 'none' | capitalize }}</span>
        <app-svg src="/assets/icons/24/chevron-down.svg" size="-1"></app-svg>
      </button>
      <div contextContent class="button-menu">
        @for (transform of transforms; track transform) {
          <app-button-menu-item
            name="text-transform"
            [analyticsExtra]="{ transform }"
            location="theme-text-transform-item"
            [color]="
              textTransform() === transform || (!textTransform() && transform === 'none') ? 'simple-primary' : 'simple'
            "
            [fullWidth]="true"
            (click)="textTransformChange.emit(transform); menu.close()"
          >
            {{ transform | capitalize }}
          </app-button-menu-item>
        }
      </div>
    </app-context-menu>
  </app-access-item-cta>
</app-access-item>
